import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, vModelText as _vModelText, withDirectives as _withDirectives, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", {
  alt: "Rekprof logo",
  class: "logo_min",
  src: "../../../../assets/logo.png"
}, null, -1)
const _hoisted_2 = { class: "inner_step_box" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "main_field" }, "Поиск по ИНН", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "hint_left hint_mini_top" }, " Введите ИНН, дождитесь загрузки и нажмите далее ", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "main_field" }, "Выберите тип заявителя", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = {
  key: 0,
  class: "hint_left"
}
const _hoisted_12 = { key: 2 }
const _hoisted_13 = {
  key: 3,
  class: "hint_left"
}
const _hoisted_14 = { key: 5 }
const _hoisted_15 = {
  key: 6,
  class: "hint_left"
}
const _hoisted_16 = { key: 8 }
const _hoisted_17 = {
  key: 9,
  class: "hint_left"
}
const _hoisted_18 = { key: 11 }
const _hoisted_19 = {
  key: 12,
  class: "hint_left"
}
const _hoisted_20 = { key: 14 }
const _hoisted_21 = {
  key: 15,
  class: "hint_left"
}
const _hoisted_22 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_menu_list = _resolveComponent("v-menu-list")!
  const _component_v_select_open = _resolveComponent("v-select-open")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    (_openBlock(), _createBlock(_component_v_menu_list, { key: 1 })),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _withDirectives(_createElementVNode("input", {
        class: "main_input",
        placeholder: "Введите ИНН",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.storeDM.save_obj.client_inn) = $event)),
        maxlength: "12",
        onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.inn_change && _ctx.inn_change(...args))),
        onPaste: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.inn_change && _ctx.inn_change(...args))),
        onkeypress: "return event.charCode >= 48 && event.charCode <= 57"
      }, null, 544), [
        [_vModelText, _ctx.storeDM.save_obj.client_inn]
      ]),
      _hoisted_5,
      _hoisted_6,
      _hoisted_7,
      _hoisted_8,
      (_openBlock(), _createBlock(_component_v_select_open, {
        options: _ctx.client_type_options,
        title_select: _ctx.client_type_title,
        default_select: _ctx.storeDM.save_obj.client_type,
        key: _ctx.storeDM.save_obj.client_type,
        onChangeSelect: _ctx.client_type_select,
        margin_top: '3px'
      }, null, 8, ["options", "title_select", "default_select", "onChangeSelect"])),
      _hoisted_9,
      _hoisted_10,
      (_ctx.storeDM.save_obj.client_type == 3)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, " Введите ОГРНИП "))
        : _createCommentVNode("", true),
      (_ctx.storeDM.save_obj.client_type == 3)
        ? _withDirectives((_openBlock(), _createElementBlock("input", {
            key: 1,
            class: "main_input",
            placeholder: "Введите ОГРНИП",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.storeDM.save_obj.client_ogrnip) = $event)),
            maxlength: "15",
            onkeypress: "return event.charCode >= 48 && event.charCode <= 57"
          }, null, 512)), [
            [_vModelText, _ctx.storeDM.save_obj.client_ogrnip]
          ])
        : _createCommentVNode("", true),
      (_ctx.storeDM.save_obj.client_type == 3)
        ? (_openBlock(), _createElementBlock("br", _hoisted_12))
        : _createCommentVNode("", true),
      (_ctx.storeDM.save_obj.client_type == 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, " Введите ОГРН "))
        : _createCommentVNode("", true),
      (_ctx.storeDM.save_obj.client_type == 1)
        ? _withDirectives((_openBlock(), _createElementBlock("input", {
            key: 4,
            class: "main_input",
            placeholder: "Введите ОГРН",
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.storeDM.save_obj.client_ogrn) = $event)),
            maxlength: "13",
            onkeypress: "return event.charCode >= 48 && event.charCode <= 57"
          }, null, 512)), [
            [_vModelText, _ctx.storeDM.save_obj.client_ogrn]
          ])
        : _createCommentVNode("", true),
      (_ctx.storeDM.save_obj.client_type == 1)
        ? (_openBlock(), _createElementBlock("br", _hoisted_14))
        : _createCommentVNode("", true),
      (_ctx.storeDM.save_obj.client_type == 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_15, " Введите КПП "))
        : _createCommentVNode("", true),
      (_ctx.storeDM.save_obj.client_type == 1)
        ? _withDirectives((_openBlock(), _createElementBlock("input", {
            key: 7,
            class: "main_input",
            placeholder: "Введите КПП",
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.storeDM.save_obj.client_kpp) = $event)),
            maxlength: "9",
            onkeypress: "return event.charCode >= 48 && event.charCode <= 57"
          }, null, 512)), [
            [_vModelText, _ctx.storeDM.save_obj.client_kpp]
          ])
        : _createCommentVNode("", true),
      (_ctx.storeDM.save_obj.client_type == 1)
        ? (_openBlock(), _createElementBlock("br", _hoisted_16))
        : _createCommentVNode("", true),
      (_ctx.storeDM.save_obj.client_type == 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_17, " Юридический адрес "))
        : _createCommentVNode("", true),
      (_ctx.storeDM.save_obj.client_type == 1)
        ? _withDirectives((_openBlock(), _createElementBlock("input", {
            key: 10,
            class: "main_input",
            placeholder: "Юридический адрес",
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.storeDM.save_obj.client_address) = $event))
          }, null, 512)), [
            [_vModelText, _ctx.storeDM.save_obj.client_address]
          ])
        : _createCommentVNode("", true),
      (_ctx.storeDM.save_obj.client_type == 1)
        ? (_openBlock(), _createElementBlock("br", _hoisted_18))
        : _createCommentVNode("", true),
      (_ctx.storeDM.save_obj.client_type == 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_19, " Введите сокращённое название организации "))
        : _createCommentVNode("", true),
      (_ctx.storeDM.save_obj.client_type == 1)
        ? _withDirectives((_openBlock(), _createElementBlock("input", {
            key: 13,
            class: "main_input",
            placeholder: "Введите сокращённое название организации",
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.storeDM.save_obj.client_smallname) = $event))
          }, null, 512)), [
            [_vModelText, _ctx.storeDM.save_obj.client_smallname]
          ])
        : _createCommentVNode("", true),
      (_ctx.storeDM.save_obj.client_type == 1)
        ? (_openBlock(), _createElementBlock("br", _hoisted_20))
        : _createCommentVNode("", true),
      (_ctx.storeDM.save_obj.client_type == 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_21, " Введите полное название организации "))
        : _createCommentVNode("", true),
      (_ctx.storeDM.save_obj.client_type == 1)
        ? _withDirectives((_openBlock(), _createElementBlock("input", {
            key: 16,
            class: "main_input",
            placeholder: "Введите полное название организации",
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.storeDM.save_obj.client_fullname) = $event))
          }, null, 512)), [
            [_vModelText, _ctx.storeDM.save_obj.client_fullname]
          ])
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("button", {
      type: "button",
      class: "white_s_btn",
      onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.go_back()))
    }, "Назад"),
    _createElementVNode("button", {
      type: "button",
      class: _normalizeClass(["next_btn", { active_btn: _ctx.step_next }]),
      disabled: !_ctx.step_next,
      onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.go_next()))
    }, " Далее ", 10, _hoisted_22)
  ], 64))
}